import { getDraftJSFieldsByType } from './schema';

export default function getBlockTexts(block) {
  const blockType = block.get('type');
  const fieldNames = getDraftJSFieldsByType(blockType);

  return fieldNames.map((fieldName) => {
    const field = block.get(fieldName);
    return field ? field.getPlainText() : undefined;
  });
}
